export default "__VITE_ASSET__Btkf5RCL__"